var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTarget(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 37C30.2843 37 37 30.2843 37 22C37 13.7157 30.2843 7 22 7C13.7157 7 7 13.7157 7 22C7 30.2843 13.7157 37 22 37ZM22 39C31.3888 39 39 31.3888 39 22C39 12.6112 31.3888 5 22 5C12.6112 5 5 12.6112 5 22C5 31.3888 12.6112 39 22 39Z",
    fill: "#1D1D1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 2H23V9H21V2Z",
    fill: "#1D1D1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 2V9H23V2H21Z",
    fill: "#1D1D1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42 21L42 23L35 23L35 21L42 21Z",
    fill: "#1D1D1B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 21L35 21L35 23L42 23L42 21Z",
    fill: "#1D1D1B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21 35H23V42H21V35Z",
    fill: "#1D1D1B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 35V42H23V35H21Z",
    fill: "#1D1D1B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21L9 23L2 23L2 21L9 21Z",
    fill: "#1D1D1B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 21L2 21L2 23L9 23L9 21Z",
    fill: "#1D1D1B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 15C20.6193 15 19.5 16.1193 19.5 17.5C19.5 18.8807 20.6193 20 22 20C23.3807 20 24.5 18.8807 24.5 17.5C24.5 16.1193 23.3807 15 22 15ZM17.5 17.5C17.5 15.0147 19.5147 13 22 13C24.4853 13 26.5 15.0147 26.5 17.5C26.5 19.9853 24.4853 22 22 22C19.5147 22 17.5 19.9853 17.5 17.5Z",
    fill: "#1D1D1B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 27C14 24.7242 15.9673 23 18.2308 23H25.7692C28.0327 23 30 24.7242 30 27V29H28V27C28 25.9658 27.0703 25 25.7692 25H18.2308C16.9297 25 16 25.9658 16 27V29H14V27Z",
    fill: "#1D1D1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTarget);
export default __webpack_public_path__ + "static/media/icon-target.502aa0b0d78b5d5df2117a13b27ea1d2.svg";
export { ForwardRef as ReactComponent };